import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsPriorityPayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY;
    id: string;
    attributes: {
      data: Array<{
        ld_priority: string;
        request_status: string;
        request_count: number;
        ld_priority_total_count: number;
      }>;
    };
  };
}

export const parseRequestsPriorityPayload = (
  payload: BaseInsightPayload
): RequestsPriorityPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      ld_priority: string;
      request_status: string;
      request_count: number;
      ld_priority_total_count: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_PRIORITY,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
